import sa from 'sa-sdk-javascript';
let TCSensors=new class{

  constructor() {
    this.options = {
      // cityId: "",
      // cityPy: "",
      // url: "",
      // grounpType: "",
      // bmtype: "",
    }
  }


  /***
   * 初始化神策可传入参数
   */
  init(options){
    if(options){
      this.options=Object.assign(this.options,options);
    }

    // console.log("init")
    var shenceImageUrl="//point.tuanche.com/1px.png";
    //初始化生成
    sa.init({
      // sdk_url: '/xunjia/static/sensorsdata.min.js',
      name: 'sa',
      // show_log:false,
      server_url: shenceImageUrl,//pathWebCommonUtils+'/img/xunjia/1px.png',
      //heatmap_url神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成。如果神策代码中 `sensorsdata.min.js` 版本是 1.9.1 及以上版本，这个参数必须配置，低于此版本不需要配置。
      // heatmap_url: "/xunjia/static/heatmap.min.js",
      //web_url 神策分析中点击分析及触达分析功能会用到此地址，代码生成工具会自动生成。如果神策后台版本及 `sensorsdata.min.js` 均是 1.10 及以上版本，这个参数不需要配置。
      //web_url:"神策分析后台地址",
      heatmap: {
        //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
        //需要 JSSDK 版本号大于 1.7
        clickmap: 'default',
        //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
        //需要 JSSDK 版本号大于 1.9.1
        scroll_notice_map: 'not_collect'
      }
    });
    this.computedDuration();
    // sa.quick('autoTrack',this.options);
  }
  pvtj(){
      sa.quick('autoTrack',this.options);
  }
  pageInfo(options){
      // sa.quick("autoTrackSinglePage");
      // sa.quick("autoTrackSinglePage",{platForm:"H5"});
      let pageInfo={
          cityPy:"",
          cityId:"",
          bmtype:"",
          source:-1,
          groupby_type:999999,
          $url: window.location.href
      }
      if(options){
          options=Object.assign(pageInfo,options)
      }
      sa.track('pageInfo',options);
  }
  //停留时长
  computedDuration(){

    // 神策停留时长埋点
    var start = new Date();

    var loadHandler = function(e) {
      start = new Date();
    };
    var unloadHandler = function (e) {
      var end = new Date();
      // 如果用户一直不关闭页面，可能出现超大值，可以根据业务需要处理，例如设置一个上限
      var duration = (end.getTime() - start.getTime()) / 1000;
      // 定义一个记录页面停留时间的事件pageView,并且保存需要的属性(停留时间和当前页面的地址)
      sa.track('pageclose', {
        pageStayTime: duration,
        $url: window.location.href
      });
    };
    function addEvent(target, type, listener) {
      if (window.addEventListener) {
        target.addEventListener(type, listener, false);
      } else {
        target.attachEvent('on' + type, listener);
      }
    }

    if ('onpageshow' in window) {

      addEvent(window, 'pageshow', loadHandler);
      addEvent(window, 'pagehide', unloadHandler);
    } else {
      addEvent(window, 'load', loadHandler);
      addEvent(window, 'unload', unloadHandler);
    }



    //在页面头部以同步的方式加载 js 代码
    var startTime = new Date();
    //定义起始时间
    var endTime = "" ;
    //定义结束时间
    window.onload = function(){
      endTime = new Date();
      sa.track('pageLoadTime',{
        loadTime:(endTime.getTime() - startTime.getTime()),
        $url: window.location.href
      })
    }

  }

  //设置城市
  setCityCode(cityCode){
    this.options.cityCode=cityCode;
  }
  //设置城市拼音
  setCityPy(cityPy){
    this.options.cityPy=cityPy;
  }
  //ABTest
  setABTest(optins){

  }
  //添加自定义属性
  setCustomAttr(optins){}

}


export default TCSensors;



// WEBPACK FOOTER //
// ./static/js/lib/TCSensors.js